import { h } from 'preact'
import TopicListView from '../topic-list-view/TopicListView'
import { TopicInfo } from '../topic-list-view/TopicListItemView'

export interface UnansweredTopicsProps {
  tab: string
  requestUrl: string
  query: {}
  attachmentCdn: string
  topics: TopicInfo[]
}

const UnansweredTopics = (props: UnansweredTopicsProps) => (
  <div className='box widget box__content qa-widget-recent-topics topic-list-view'>
    <TopicListView {...props} />
  </div>
)

export default UnansweredTopics
